export default __webpack_public_path__ + "images/QF.629e223.png";